import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Checkbox from '@components/checkbox/Checkbox'

import theme from '@theme/Theme'

const icon = {
  name: 'incident_key' as IconName,
  color: theme.colors.closed,
}

const CheckboxesSection = () => {
  const [value, setValue] = React.useState(false)

  return (
    <Section>
      <SectionTitle>Checkboxes</SectionTitle>
      <Container>
        <Checkbox value={value} onClick={() => setValue(!value)} label="Label" />
      </Container>
      <Container>
        <Checkbox disabled value={value} onClick={() => setValue(!value)} label="Label" />
      </Container>
      <Container>
        <Checkbox iconOnTheRight value={value} onClick={() => setValue(!value)} label="Label" />
      </Container>
      <Container>
        <Checkbox iconOnTheRight label="Label" onClick={() => setValue(!value)} value={value} info={39} icon={icon} />
      </Container>
    </Section>
  )
}

export default CheckboxesSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`
